import { render, staticRenderFns } from "./CSVExport.vue?vue&type=template&id=67472e04&scoped=true"
import script from "./CSVExport.vue?vue&type=script&lang=js"
export * from "./CSVExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67472e04",
  null
  
)

export default component.exports